import { mapActions } from 'vuex';
import { parseBool } from '@/utils/parse-functions';

export default {
	methods: {
		...mapActions('communicationHub', ['showToastAction']),
		showHeaderToast({
			title,
			subtitle,
			message,
			state,
			iconClassName,
			dismissibleTime,
			siteLevel
		}) {
			this.showToastAction({
				title: title,
				subtitle: subtitle,
				message: message,
				state: state,
				iconClassName: iconClassName,
				dismissibleTime: parseInt(dismissibleTime),
				siteLevel: parseBool(siteLevel)
			});
		}
	}
};
